import { useState } from "react";
import { motion } from "framer-motion";
import TakeIcon from "./Icons/TakeIcon";
import Divider from "./Divider";
import pirateShopItems from "./PirateShopItems";
import { starsBuyPhrases, starsNotEnoughPhrases } from "./ShopPhrases";
import TgStarIcon from "./Icons/TgStarIcon";
import FloatingIcons from "./FloatingIcons";
import { useSocket } from "./SocketContext";

const Pirate = ({
  t,
  audioManager,
  setNowOpen,
  dispatch,
  localProfile,
  addToast,
  setSortedItems,
}) => {
  const { emit, on, off, once, isConnected } = useSocket();
  const handleBuy = (currency) => {
    try {
      setShopBuyButtonDisabled(true); // Блокируем кнопку покупки
      setActiveShopItemQuantity(1); // Сбрасываем количество предметов

      // Определяем стоимость в зависимости от валюты
      const cost =
        currency === "ducks"
          ? activeShopItem.cost * activeShopItemQuantity
          : activeShopItem.ddCost * activeShopItemQuantity;

      console.log("Emitting purchaseItem:", {
        playerId: localProfile.id,
        item: { title: activeShopItem.title, quantity: activeShopItemQuantity },
        cost: cost, // Используем рассчитанную стоимость
        currency: currency, // Передаем выбранную валюту
      });

      // Удаляем предыдущие обработчики, чтобы избежать дублирования
      off("purchaseSuccess");
      off("purchaseError");

      // Отправляем запрос на покупку
      emit("purchaseItem", {
        playerId: localProfile.id,
        item: {
          title: activeShopItem.title,
          quantity: activeShopItemQuantity,
          type: activeShopItem.type,
        },
        cost: cost, // Передаем рассчитанную стоимость
        currency: currency, // Указываем валюту
      });

      // Обработка успешного обновления от сервера
      once("purchaseSuccess", (data) => {
        audioManager.play("s_coins"); // Воспроизводим звук покупки

        // Выбираем случайную фразу для отображения
        const randomPhrase = Math.floor(Math.random() * starsBuyPhrases.length);
        setShopPhrase(t(starsBuyPhrases[randomPhrase]));

        // Обновляем локальное состояние
        const { items, ducks, dealDucks } = data; // Получаем обновленные данные
        setShopBuyButtonDisabled(false); // Разблокируем кнопку
        setActiveShopItem(null); // Сбрасываем активный предмет
        setSortedItems(items); // Обновляем список предметов

        // Обновляем состояние через dispatch
        dispatch({ type: "UPDATE_ITEMS", payload: items });
        if (currency === "ducks") {
          dispatch({ type: "UPDATE_DUCKS", payload: ducks });
        } else if (currency === "dealDucks") {
          dispatch({ type: "UPDATE_DEAL_DUCKS", payload: dealDucks });
        }

        console.log("Items successfully updated on server and local profile.");
        addToast(t(activeShopItem.title) + " " + t("received"), "info"); // Показываем уведомление
      });

      // Обработка ошибки на сервере
      once("purchaseError", ({ message }) => {
        setShopBuyButtonDisabled(false); // Разблокируем кнопку
        setActiveShopItem(null); // Сбрасываем активный предмет

        console.error("Error updating items on server:", message);

        // Выбираем случайную фразу для отображения
        const randomPhrase = Math.floor(
          Math.random() * starsNotEnoughPhrases.length
        );
        setShopPhrase(t(starsNotEnoughPhrases[randomPhrase]));

        audioManager.play("s_nope"); // Воспроизводим звук ошибки
        addToast(message, "error"); // Показываем уведомление об ошибке
      });
    } catch (error) {
      console.error("Error in purchaseItem:", error);
    }
  };

  const [shopPhrase, setShopPhrase] = useState(
    "Пррривет мешок с золотом!.. ой то есть. Лучший клиент!"
  );

  const [activeShopItem, setActiveShopItem] = useState(null);

  const [activeShopItemQuantity, setActiveShopItemQuantity] = useState(1);
  const [shopBuyButtonDisabled, setShopBuyButtonDisabled] = useState(false);

  return (
    <>
      <div className="inventory-title">
        <div className="invenory-title-text">{t("Pirate Bay")}</div>
        <TakeIcon
          onClick={() => {
            setNowOpen("city");
            audioManager.stopAll();
            audioManager.play("s_city");
          }}
          className="back-icon"
          fill="#e0e0e0dc"
          size="20px"
        ></TakeIcon>
      </div>
      <div className="pirate-image">
        <motion.div
          key={shopPhrase}
          initial={{ y: 20, rotate: -20 }}
          animate={{ y: 0, rotate: 0 }}
          className="shop-dialog"
        >
          {t(shopPhrase)}
        </motion.div>
      </div>
      <motion.div
        initial={{ x: 30, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        className="inventory-container add-ui-container"
      >
        {pirateShopItems.length > 0 && (
          <div>
            <div className="shop-items-wrapper">
              {pirateShopItems.map((item, index) => (
                <div
                  style={{ backgroundColor: item.color }}
                  key={index}
                  onClick={() => {
                    setActiveShopItem(item);
                    audioManager.play("s_buttonClick");
                  }}
                  className="shop-item-container"
                >
                  <img
                    className="shop-item-img"
                    src={item.miniimg}
                    alt="miniaura"
                  ></img>
                  <div className="shop-item-title">{t(item.title)}</div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 4,
                      backgroundColor: "rgba(0,0,0,0.5)",
                      width: "100%",
                      justifyContent: "center",
                      borderRadius: 4,
                    }}
                  >
                    {item.cost}
                    <TgStarIcon
                      size={14}
                      color={"rgb(235, 198, 98)"}
                    ></TgStarIcon>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </motion.div>
      {activeShopItem != null && (
        <>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            className="buy-confirm-window"
          >
            <div
              style={{
                position: "absolute",
                width: "100vw",
                left: 0,
                top: 100,
                zIndex: 1,
              }}
            >
              <FloatingIcons />
            </div>

            <div className="buy-confirm-wrapper">
              <div
                onClick={() => {
                  setActiveShopItem(null);
                }}
                style={{
                  position: "absolute",
                  top: 15,
                  right: 20,
                  fontSize: 18,
                }}
              >
                ✖
              </div>
              <div
                style={{
                  fontSize: 12,
                  opacity: 0.5,
                  marginBottom: "30px",
                  textTransform: "uppercase",
                }}
              >
                {t("Purchase details")}
              </div>
              <img
                src={activeShopItem.miniimg}
                width={"120px"}
                alt="activeShopItem mini img"
              ></img>
              <div style={{ textAlign: "center" }}>
                <div style={{ marginBottom: "5px" }}>
                  {t(activeShopItem.title)}
                </div>
              </div>
              <Divider />
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 8,
                  justifyContent: "center",
                  alignItems: "center",
                  transform: "translateY(-3px)",
                }}
              >
                {t("Total: ")}
                <motion.div
                  key={activeShopItemQuantity}
                  initial={{ scale: 1.1 }}
                  animate={{ scale: 1 }}
                  style={{
                    display: "flex",
                    gap: "7px",
                    alignItems: "center",
                  }}
                >
                  {activeShopItem.cost > 0 && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "4px 8px",
                        gap: 4,
                        fontSize: 20,
                        borderRadius: 8,
                      }}
                    >
                      {activeShopItem.cost * activeShopItemQuantity}
                      <TgStarIcon color={"rgb(235, 198, 98)"} size={"20px"} />
                    </div>
                  )}
                </motion.div>
              </div>

              <div
                style={{
                  display: "flex",
                  width: "100%",
                  gap: 10,
                }}
              >
                <button
                  disabled={shopBuyButtonDisabled}
                  onClick={() => handleBuy("dealDucks")}
                  style={{
                    backgroundColor: "rgb(235, 198, 98)",
                    fontSize: 16,
                    fontWeight: 600,
                  }}
                  className="button-buy"
                >
                  {t("Proceed")}
                </button>
              </div>
            </div>
          </motion.div>
          <div
            onClick={() => {
              setActiveShopItem(null);
              setActiveShopItemQuantity(1);
            }}
            className="black-screen"
          ></div>
        </>
      )}
    </>
  );
};

export default Pirate;
